import { DateTime } from 'luxon';
import type { TimeValidityType } from '../../../../models/time-validity-type.enum';
import type { TimeValidityUnit } from '../../../../models/time-validity-unit.enum';
import type { ITimeValidity } from '../../../../models/time-validity.model';

export default class TimeValidityApiModel {
  public static mapToBusinessModel(apiModel: TimeValidityApiModel): ITimeValidity {
    return {
      type: apiModel.type,
      amount: apiModel.amount,
      unit: apiModel.unit,
      fromDate: apiModel.fromDate ? DateTime.fromISO(apiModel.fromDate) : undefined,
      toDate: apiModel.toDate ? DateTime.fromISO(apiModel.toDate) : undefined,
      fromDateTime: apiModel.fromDateTime ? DateTime.fromISO(apiModel.fromDateTime) : undefined,
      toDateTime: apiModel.toDateTime ? DateTime.fromISO(apiModel.toDateTime) : undefined,
    };
  }

  type!: TimeValidityType;
  amount?: number | undefined;
  unit!: TimeValidityUnit;
  fromDate?: string;
  toDate?: string;
  fromDateTime?: string;
  toDateTime?: string;
}
